import { Navigate, useSearchParams } from 'react-router-dom'
import { legacyToDesk } from '../../lib/deskPeriod'
import { deskPath } from '../../lib/deskTabs'

/** The old all-titles overview is now the desk's Today tab for All titles. */
export function VisitorsOverview() {
  const [sp] = useSearchParams()
  return <Navigate to={deskPath('all', 'today', legacyToDesk(sp).toString())} replace />
}
